import React from 'react';
import { View, StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import Text from '@/components/Typography/Text';
import Icon from '@/components/Icon';

const ExploreCardOverlay = React.memo(({ prompt, modelName, modelSlug, mediaType, duration, isPlusShowcase, hovered, variationCount }) => {
  return (
    <View style={styles.overlay} pointerEvents="none">
      {isPlusShowcase && (
        <View style={styles.plusBadge}>
          <Icon name="bolt" size={8} color="#fff" solid />
          <Text size="xxs" weight="semiBold" color="white">Plus</Text>
        </View>
      )}
      {/* Tiny "this card has N variations" hint in the top-right. Only shown
          when there is at least one derived item — keeps the corner clean
          for the vast majority of cards without provenance. */}
      {variationCount > 0 && (
        <View style={styles.variationBadge}>
          <Icon name="code-branch" size={9} color="#fff" />
          <Text size="xxs" weight="semiBold" color="white">{variationCount}</Text>
        </View>
      )}
      <LinearGradient
        colors={['transparent', 'rgba(0,0,0,0.7)']}
        style={styles.gradient}
      >
        <Text
          size="xs"
          color="white"
          numberOfLines={hovered ? 6 : 2}
          style={styles.prompt}
        >
          {prompt}
        </Text>

        <View style={styles.badges}>
          {modelName ? (
            <View style={styles.badge}>
              <Icon name="microchip" size={10} color="#fff" />
              <Text size="xxs" color="white" numberOfLines={1}>
                {modelName}
              </Text>
            </View>
          ) : null}

          {mediaType === 'video' && duration ? (
            <View style={styles.badge}>
              <Icon name="clock" size={10} color="#fff" />
              <Text size="xxs" color="white">
                {duration}s
              </Text>
            </View>
          ) : null}

          {mediaType === 'music' ? (
            <View style={styles.badge}>
              <Icon name="music" size={10} color="#fff" />
              <Text size="xxs" color="white">Music</Text>
            </View>
          ) : null}

          {mediaType === '3d' ? (
            <View style={styles.badge}>
              <Icon name="cube" size={10} color="#fff" solid />
              <Text size="xxs" color="white">3D</Text>
            </View>
          ) : null}
        </View>
      </LinearGradient>
    </View>
  );
});

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'flex-end',
  },
  variationBadge: {
    position: 'absolute',
    top: 6,
    right: 6,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  plusBadge: {
    position: 'absolute',
    top: 6,
    left: 6,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
    backgroundColor: 'rgba(139, 92, 246, 0.85)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  gradient: {
    padding: 10,
    paddingTop: 40,
  },
  prompt: {
    marginBottom: 6,
    lineHeight: 16,
  },
  badges: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  badge: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
    backgroundColor: 'rgba(255,255,255,0.15)',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
});

export default ExploreCardOverlay;
